module.exports = __webpack_public_path__ + "img/menu-subscriptions.2de395ef.svg";